var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadDarkOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.99,
    height: 15.99,
    viewBox: "0 0 15.99 15.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12741",
    "data-name": "Path 12741",
    d: "M3.988,12.746a5.576,5.576,0,0,1-1.431-2.052A5.642,5.642,0,0,1,3.719,4.646L5.192,6.122a.151.151,0,0,0,.247-.1l.8-5.278A.131.131,0,0,0,6.094.6L.825,1.4a.151.151,0,0,0-.1.247L2.2,3.13a7.79,7.79,0,0,0,.74,11.535,7.694,7.694,0,0,0,4.623,1.661.4.4,0,0,0,.4-.336l.207-1.355a.4.4,0,0,0-.389-.456A5.588,5.588,0,0,1,3.988,12.746Z",
    transform: "translate(0 -0.596)",
    fill: "#455079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12742",
    "data-name": "Path 12742",
    d: "M246.814,21.751a7.79,7.79,0,0,0-.74-11.535,7.694,7.694,0,0,0-4.622-1.661.4.4,0,0,0-.4.336l-.207,1.355a.4.4,0,0,0,.389.456,5.622,5.622,0,0,1,4.064,9.533l-1.473-1.476a.151.151,0,0,0-.246.1l-.8,5.278a.131.131,0,0,0,.149.15l5.269-.806a.152.152,0,0,0,.1-.247Z",
    transform: "translate(-233.028 -8.296)",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadDarkOutline);
export default __webpack_public_path__ + "static/media/reload-dark-outline.94739318bd736bee9e3b8ce57835bb78.svg";
export { ForwardRef as ReactComponent };